import { SplitButtonOptions } from '../@types/splitButtonOptions';
import { PATH_DASHBOARD } from './paths'

type HeaderOptions = {
  [key: string]: {
    filterOff?: boolean;
    buttons: SplitButtonOptions;
  };
};

const product = {
  buttons: [
    {
      title: 'New Product',
      path: PATH_DASHBOARD.dictionaries.product.new,
    },
    {
      title: 'Import Product',
      path: PATH_DASHBOARD.dictionaries.product.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
};

const storages = {
  buttons: [
    {
      title: 'New Storage',
      path: PATH_DASHBOARD.dictionaries.storages.new,
    },
    {
      title: 'Import Storages',
      path: PATH_DASHBOARD.dictionaries.storages.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
};

const accounts = {
  buttons: [
    {
      title: 'New Account',
      path: PATH_DASHBOARD.dictionaries.accounts.new,
    },
    {
      title: 'Import Accounts',
      path: PATH_DASHBOARD.dictionaries.accounts.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
};

const transactionArticles = {
  buttons: [
    {
      title: 'New Article',
      path: PATH_DASHBOARD.dictionaries.transactionArticles.new,
    },
    {
      title: 'Import Articles',
      path: PATH_DASHBOARD.dictionaries.transactionArticles.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
};

const sourceOrders = {
  buttons: [
    {
      title: 'New Source',
      path: PATH_DASHBOARD.dictionaries.sourceOrders.new,
    },
    {
      title: 'Import Sources',
      path: PATH_DASHBOARD.dictionaries.sourceOrders.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
};

const ozonSellerAccounts = {
  buttons: [
    {
      title: 'New Ozon account',
      path: PATH_DASHBOARD.ozon.sellerAccounts.new,
    },
  ],
};

const wbSellerAccounts = {
  buttons: [
    {
      title: 'New WB account',
      path: PATH_DASHBOARD.wb.sellerAccounts.new,
    },
  ],
};

const avitoSellerAccounts = {
  buttons: [
    {
      title: 'New Avito account',
      path: PATH_DASHBOARD.avito.sellerAccounts.new,
    },
  ],
};

const deliveryServices = {
  buttons: [
    {
      title: 'New Service',
      path: PATH_DASHBOARD.dictionaries.deliveryServices.new,
    },
    {
      title: 'Import Services',
      path: PATH_DASHBOARD.dictionaries.deliveryServices.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
};

const documentTemplates = {
  buttons: [
    {
      title: 'New Template',
      path: PATH_DASHBOARD.dictionaries.documentTemplates.new,
    },
  ],
};


const category = {
  buttons: [
    {
      title: 'New Category',
      path: PATH_DASHBOARD.dictionaries.category.new,
    },
    {
      title: 'Import Categories',
      path: PATH_DASHBOARD.dictionaries.category.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
}

const brand = {
  buttons: [
    {
      title: 'New Brand',
      path: PATH_DASHBOARD.dictionaries.brand.new,
    },
    {
      title: 'Import Brands',
      path: PATH_DASHBOARD.dictionaries.brand.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
}

const groups = {
  buttons: [
    {
      title: 'New Group',
      path: PATH_DASHBOARD.administration.groups.new,
    },
    {
      title: 'Import Groups',
      path: PATH_DASHBOARD.administration.groups.import,
      icon: 'mdi:plus-box-multiple-outline',
    },
  ],
}

export const headerOptions: HeaderOptions = {
  [PATH_DASHBOARD.dictionaries.product.scroller]: product,
  [PATH_DASHBOARD.dictionaries.product.view(0)]: product,
  [PATH_DASHBOARD.dictionaries.storages.scroller]: storages,
  [PATH_DASHBOARD.dictionaries.storages.view(0)]: storages,
  [PATH_DASHBOARD.dictionaries.accounts.scroller]: accounts,
  [PATH_DASHBOARD.dictionaries.accounts.view(0)]: accounts,
  [PATH_DASHBOARD.dictionaries.transactionArticles.scroller]: transactionArticles,
  [PATH_DASHBOARD.dictionaries.transactionArticles.view(0)]: transactionArticles,
  [PATH_DASHBOARD.dictionaries.sourceOrders.scroller]: sourceOrders,
  [PATH_DASHBOARD.dictionaries.sourceOrders.view(0)]: sourceOrders,
  [PATH_DASHBOARD.ozon.sellerAccounts.scroller]: ozonSellerAccounts,
  [PATH_DASHBOARD.ozon.sellerAccounts.view(0)]: ozonSellerAccounts,
  [PATH_DASHBOARD.wb.sellerAccounts.scroller]: wbSellerAccounts,
  [PATH_DASHBOARD.wb.sellerAccounts.view(0)]: wbSellerAccounts,
  [PATH_DASHBOARD.avito.sellerAccounts.scroller]: avitoSellerAccounts,
  [PATH_DASHBOARD.avito.sellerAccounts.view(0)]: avitoSellerAccounts,
  [PATH_DASHBOARD.dictionaries.deliveryServices.scroller]: deliveryServices,
  [PATH_DASHBOARD.dictionaries.deliveryServices.view(0)]: deliveryServices,
  [PATH_DASHBOARD.dictionaries.documentTemplates.scroller]: documentTemplates,
  [PATH_DASHBOARD.dictionaries.documentTemplates.view(0)]: documentTemplates,
  [PATH_DASHBOARD.dictionaries.category.scroller]: category,
  [PATH_DASHBOARD.dictionaries.category.view(0)]: category,
  [PATH_DASHBOARD.dictionaries.brand.scroller]: brand,
  [PATH_DASHBOARD.dictionaries.brand.view(0)]: brand,
  [PATH_DASHBOARD.administration.user.scroller]: {
    buttons: [
      {
        title: 'New User',
        path: PATH_DASHBOARD.administration.user.new,
      },
    ],
  },
  [PATH_DASHBOARD.administration.groups.scroller]: groups,
  [PATH_DASHBOARD.administration.groups.view(0)]: groups,
  [PATH_DASHBOARD.storageDocuments.scroller]: {
    buttons: [
      {
        title: 'New Storage Documents',
        path: PATH_DASHBOARD.storageDocuments.new,
      },
    ],
  },
  [PATH_DASHBOARD.transactions.scroller]: {
    buttons: [
      {
        title: 'New Transactions',
        path: PATH_DASHBOARD.transactions.new,
      },
    ],
  },
  [PATH_DASHBOARD.storageShipments.scroller]: {
    buttons: [
      {
        title: 'New Shipment',
        path: PATH_DASHBOARD.storageShipments.new,
      },
    ],
  },
  [PATH_DASHBOARD.sales.scroller]: {
    buttons: [
      {
        title: 'New Sale',
        path: PATH_DASHBOARD.sales.new,
      },
    ],
  },
  [PATH_DASHBOARD.administration.i18nLang.scroller]: {
    filterOff: true,
    buttons: [
      {
        title: 'New language',
        path: PATH_DASHBOARD.administration.i18nLang.new,
      },
      {
        title: 'Import languages',
        path: PATH_DASHBOARD.administration.i18nLang.import,
        icon: 'mdi:plus-box-multiple-outline',
      },
    ],
  },
  [PATH_DASHBOARD.administration.i18nKeys.scroller]: {
    buttons: [
      {
        title: 'New translation',
        path: PATH_DASHBOARD.administration.i18nKeys.new,
      },
    ],
},
  [PATH_DASHBOARD.general.checkPrice.scroller]: {
    buttons: [
      {
        title: 'New monitor',
        path: PATH_DASHBOARD.general.checkPrice.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.checkPrice.view(0)]: {
    buttons: [
      {
        title: 'New link',
        path: PATH_DASHBOARD.general.checkPrice.newLink(0),
      },
    ],
  },
  [PATH_DASHBOARD.general.checkPrice.viewLink(0, 0)]: {
    buttons: [
      {
        title: 'New link',
        path: PATH_DASHBOARD.general.checkPrice.newLink(0),
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.scroller]: {
    buttons: [
      {
        title: 'New Site',
        path: PATH_DASHBOARD.general.sites.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.shop.categories.scroller]: {
    buttons: [
      {
        title: 'New Category',
        path: PATH_DASHBOARD.general.sites.shop.categories.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.shop.products.scroller]: {
    buttons: [
      {
        title: 'New Product',
        path: PATH_DASHBOARD.general.sites.shop.products.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.shop.payment.scroller]: {
    buttons: [
      {
        title: 'New Payment Method',
        path: PATH_DASHBOARD.general.sites.shop.payment.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.shop.delivery.scroller]: {
    buttons: [
      {
        title: 'New Delivery Method',
        path: PATH_DASHBOARD.general.sites.shop.delivery.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.news.scroller]: {
    buttons: [
      {
        title: 'New News',
        path: PATH_DASHBOARD.general.sites.news.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.news.view(0)]: {
    buttons: [
      {
        title: 'New News',
        path: PATH_DASHBOARD.general.sites.news.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.pages.scroller]: {
    buttons: [
      {
        title: 'New Page',
        path: PATH_DASHBOARD.general.sites.pages.new,
      },
    ],
  },
  [PATH_DASHBOARD.general.sites.pages.view(0)]: {
    buttons: [
      {
        title: 'New Page',
        path: PATH_DASHBOARD.general.sites.pages.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.suppliers.scroller]: {
    buttons: [
      {
        title: 'New Supplier',
        path: PATH_DASHBOARD.procurement.suppliers.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.suppliers.view(0)]: {
    buttons: [
      {
        title: 'New Supplier',
        path: PATH_DASHBOARD.procurement.suppliers.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.requests.scroller]: {
    buttons: [
      {
        title: 'New Request',
        path: PATH_DASHBOARD.procurement.requests.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.requests.view(0)]: {
    buttons: [
      {
        title: 'New Request',
        path: PATH_DASHBOARD.procurement.requests.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.contracts.scroller]: {
    buttons: [
      {
        title: 'New Contract',
        path: PATH_DASHBOARD.procurement.contracts.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.contracts.view(0)]: {
    buttons: [
      {
        title: 'New Contract',
        path: PATH_DASHBOARD.procurement.contracts.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.deliveries.scroller]: {
    buttons: [
      {
        title: 'New Delivery',
        path: PATH_DASHBOARD.procurement.deliveries.new,
      },
    ],
  },
  [PATH_DASHBOARD.procurement.deliveries.view(0)]: {
    buttons: [
      {
        title: 'New Delivery',
        path: PATH_DASHBOARD.procurement.deliveries.new,
      },
    ],
  },
};
